import React from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const CurrencyField = React.forwardRef(({
  value,
  onChange,
  onNumberChange,
  decimal = 2,
  ...remaining
}, ref) => {
  const handleValueChange = (values) => {
    const { floatValue } = values;
    if (onNumberChange) {
      onNumberChange(floatValue);
    }
  };

  return (
    <NumericFormat
      customInput={TextField}
      getInputRef={ref}
      value={value}
      onValueChange={handleValueChange}
      onChange={onChange}
      thousandSeparator={true}
      decimalScale={decimal}
      fixedDecimalScale={true}
      prefix="$"
      allowNegative={false}
      {...remaining}
    />
  );
});

CurrencyField.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  onNumberChange: PropTypes.func,
  decimal: PropTypes.number,
};

export default CurrencyField; 